"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var storageKeys = {
    apiToken: 'ui.store.apiToken',
    languageIsoCode: 'ui.store.languageIsoCode',
    i18n: 'ui.store.translations',
    permissions: 'ui.store.permissions',
    loggedUser: 'ui.store.loggedUser',
};
exports.getItem = function (key) { return localStorage.getItem(key); };
exports.setItem = function (key, value) { return localStorage.setItem(key, value); };
exports.removeItem = function (key) { return localStorage.removeItem(key); };
exports.default = {
    getApiToken: function () { return exports.getItem(storageKeys.apiToken); },
    getLanguageIsoCode: function () { return exports.getItem(storageKeys.languageIsoCode); },
    getI18n: function () { return exports.getItem(storageKeys.i18n); },
    getPermissions: function () { return JSON.parse(exports.getItem(storageKeys.permissions) || '[]'); },
    getLoggedUser: function () { return exports.getItem(storageKeys.loggedUser); },
    setApiToken: function (value) { return exports.setItem(storageKeys.apiToken, value); },
    setLanguageIsoCode: function (value) { return exports.setItem(storageKeys.languageIsoCode, value); },
    setI18n: function (value) { return exports.setItem(storageKeys.i18n, value); },
    setPermissions: function (value) { return exports.setItem(storageKeys.permissions, JSON.stringify(value)); },
    setLoggedUser: function (value) { return exports.setItem(storageKeys.loggedUser, value); },
    removeApiToken: function () { return exports.removeItem(storageKeys.apiToken); },
    removeLoggedUser: function () { return exports.removeItem(storageKeys.loggedUser); },
};
